// 환경 판별 — 서드파티 스크립트(GTM/Amplitude)를 로드할지 결정하는 단일 기준.
//
// 이 파일이 생긴 이유: 레포에 프로덕션 판별 관용구가 세 개로 갈라져 있었고 서로 어긋났다.
//   1) NEXT_PUBLIC_API_URL === "https://api.pathrade.com"  → GTM 게이트
//   2) NODE_ENV === "production"                            → Sentry
//   3) window.location.origin === "https://pathrade.com"    → Amplitude
// 1번은 환경 판별자가 아니다. .env 와 .env.local 이 모두 프로덕션 API 를 가리키고 있어
// 개발자 로컬호스트에서도 참이 되고, 그 결과 GTM 은 로컬에서 초기화되는데 Amplitude 는
// 되지 않는 비대칭이 있었다. 프로덕션 정적 export 는 아래 호스트에서만 서빙되므로
// 호스트가 유일하게 믿을 수 있는 신호다.

export const PRODUCTION_HOSTS = ["pathrade.com", "www.pathrade.com"] as const;

/** 실제 프로덕션 사이트를 보고 있는지. 서드파티 계측 로드 여부의 기준. */
export function isProduction(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return (PRODUCTION_HOSTS as readonly string[]).includes(
    window.location.hostname
  );
}

/**
 * 프로덕션 API(실데이터)를 보고 있는지. 환경 구분이 아니다.
 * 로컬 개발에서도 참이 될 수 있으므로 계측 게이트로 쓰지 말 것.
 */
export function isProductionApi(): boolean {
  return process.env.NEXT_PUBLIC_API_URL === "https://api.pathrade.com";
}
